import React, { useState } from 'react';
import { connect } from 'react-redux';
import { LOADING } from 'store';
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Modal,
  OverlayTrigger,
  Tooltip,
  Spinner,
  Alert,
  Popover,
  Badge
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import Currency, { currencyReverse } from 'helpers/Currency';
import FileUploadMultiple, { File } from 'components/FileUploadMultiple';
import { api } from 'services';
import arrayAppend from 'helpers/array-append';
import { formatDate, parseDate, parseDateBR } from 'helpers/date';
import style from './style.module.scss';
import Dialog from 'react-bootstrap-dialog';
import { toast } from 'react-toastify';
import swal from '../../../../helpers/swal';
import banks from 'helpers/banks_codes.json';
import { InfoRounded } from '@material-ui/icons';
import Input from 'helpers/Input';

import BR from 'date-fns/locale/pt-BR';
import { is } from 'bluebird';
import ReactTooltip from 'react-tooltip';

registerLocale('pt-BR', BR);

const EventsFormExpenseDescriptions = ({
  eventId,
  expenseDescriptions,
  setExpenseDescriptions,
  expectedItems,
  setExpectedItems,
  loading,
}) => {
  const [showModal, setShowModal] = useState(false);

  const [id, setId] = useState('');
  const [serviceProvider, setServiceProvider] = useState('');
  const [document, setDocument] = useState('');
  const [item, setItem] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [value, setValue] = useState('');
  const [valueNonRefundable, setValueNonRefundable] = useState('');
  const [description, setDescription] = useState('');
  const [nature, setNature] = useState('Não Reembolsável');
  const [costCenter, setCostCenter] = useState('');
  const [project, setProject] = useState('');
  const [projectAction, setProjectAction] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [isLoad, setLoad] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState('');
  const [bankCode, setBankCode] = useState('');
  const [agency, setAgency] = useState('');
  const [account, setAccount] = useState('');
  const [billetDueDate, setBilletDueDate] = useState('');
  const [bankName, setBankName] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [generatePayment, setGeneratePayment] = useState(true);
  const [issuanceDate, setIssuanceDate] = useState('');

  const dueDateMin = new Date(new Date().setDate(new Date().getDate() + 7));

  const { t } = useTranslation();
  let dialog;

  const handleHideModal = () => {
    setId('');
    setServiceProvider('');
    setDocument('');
    setItem('');
    setInvoiceNumber('');
    setDueDate('');
    setValue('');
    setDescription('');
    setNature('Reembolsável');
    setCostCenter('');
    setProject('');
    setProjectAction('');
    setFiles([]);
    setFilesComments([]);
    setShowModal(false);
    
    setPaymentMethod('');
    setBankCode('');
    setAgency('');
    setAccount('');
  };

  const handleEdit = (k) => {
    const description = [...expenseDescriptions][k];

    setId(description.id);
    setServiceProvider(description.service_provider);
    setDocument(description.document);
    setItem(description.event_item_id);
    setInvoiceNumber(description.invoice_number);
    setDueDate(description.due_date);
    setValue(description.value);
    setValueNonRefundable(description.non_refundable);
    setDescription(description.description);
    setNature(description.nature);
    setCostCenter(description.cost_center);
    setProject(description.project);
    setProjectAction(description.project_action);
    setIssuanceDate(description.issuance_date);

    setShowModal(true);

    setPaymentMethod(description.payment_method_id);
    setBankCode(description.bank_code);
    setAgency(description.agency);
    setAccount(description.account);
    bankName(description.bank_name)

    setGeneratePayment(description.generate_payment ? true : false);
  };

  const handleSave = () => {
    loading(true);
    setLoad(true);
    const formData = new FormData();

    if (!!id) formData.append('_method', 'PUT');

    formData.append('event_id', eventId);
    formData.append('status_id', 6);
    formData.append('event_item_id', item);
    formData.append('service_provider', serviceProvider);
    formData.append('invoice_number', invoiceNumber);
    formData.append('due_date',  dueDate ? formatDate(dueDate) : "");
    formData.append('issuance_date',  issuanceDate ? formatDate(issuanceDate) : "");
    formData.append('value', currencyReverse(value));
    formData.append('non_refundable', currencyReverse(valueNonRefundable));
    formData.append('description', description);
    formData.append('nature', currencyReverse(value)>0?"Reembolsável":"Não Reembolsável");
    // formData.append('cost_center', costCenter);
    formData.append('project', project);
    formData.append('project_action', projectAction);
    formData.append('document', document);
    
    arrayAppend(formData, 'files', files);
    arrayAppend(formData, 'files_comments', filesComments);
    formData.append('payment_method_id', paymentMethod);
    if(paymentMethod == 2){
      formData.append('bank_code', paymentMethod == 2 ? bankCode : "");
      formData.append('agency', paymentMethod == 2 ? agency : "");
      formData.append('account', paymentMethod == 2 ? account : "");
      formData.append('bank_name', paymentMethod == 2 ? bankName : "");
    } else if(paymentMethod == 1) {
      formData.append('billet_due_date', paymentMethod == 1 ? formatDate(dueDate): "");
    }

    formData.append('generate_payment', parseInt(generatePayment ? 1 : 0));

    api
      .post(
        !!id
          ? `event-expense-descriptions/${id}`
          : 'event-expense-descriptions',
        formData, 
        {
          headers: {
            'X-Success-Message': `Item ${!id ? 'adicionado' : 'Atualizado'} com sucesso`,
            'X-Show-Alert': true
          }
        }
      )
      .then(() => {
        handleHideModal();
        refreshExpectedDescriptions();
      })
      .finally(() => loading(false) && setLoad(false))
      .catch((error) => {
        loading(false) && setLoad(false);
      });
  };

  const refreshExpectedDescriptions = async () => {
    await api
      .get(`event-expense-descriptions/list-by-event/${eventId}`)
      .then(({ data }) =>
        setExpenseDescriptions(
          data.map((description) => ({
            ...description,
            ...{
              due_date: description.due_date ? new Date(parseDate(description.due_date)) : "",
              issuance_date: description.issuance_date ? new Date(parseDate(description.issuance_date)) : "",
              hidden: true,
            },
          }))
        )
      );

    await api
      .get(`event-items/list-by-event/${eventId}`)
      .then(({ data }) => setExpectedItems(data));

    loading(false);
  };  

  const getBankName = code => {
    const [data] = banks.filter(bank => bank.value == code);
    if (data) {
      return `${data.value} - ${data.label}`;  
    }
    return "";
  }

  const setHidden = (value, k) => {
    const updateArray = [...expenseDescriptions];
    updateArray[k].hidden = value;
    setExpenseDescriptions(updateArray);
  };

  const handleDelete = (id) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:expense description delete'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          loading(true);
          api.delete(`event-expense-descriptions/${id}`,{
            headers: {
              'X-Success-Message': 'Item removido com sucesso!',
              'X-Show-Alert': true
            }
          }).then(() => {
            loading(false);
            refreshExpectedDescriptions();
            //toast.success('Deletado com sucesso!');
          });
        }),
      ],
      bgSize: 'small',
    });
  };

  const bankAccountRender = () => ( // dados conta bancaria 
    <Row>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>Banco</Form.Label>
          <Form.Control
            as="select"
            value={bankCode}
            onChange={(e)=> {
              setBankCode(e.target.value)
              const [data] = banks.filter(bank => bank.value == e.target.value);
              bankName(data.label)
            }}
          >
            <option value="" selected>Selecione Um banco</option>
            {banks.map(bank => (
              <option value={bank.value}>{`${bank.value} - ${bank.label}`}</option>
            ))}
          </Form.Control>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Agência</Form.Label>
          <Form.Control
            value={agency}
            onChange={(e) => setAgency(e.target.value)}
            required={paymentMethod == 2}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Conta</Form.Label>
          <Form.Control
            value={account}
            onChange={(e) => setAccount(e.target.value)}
            required={paymentMethod == 2}
          />
        </Form.Group>
      </Col>        
      <Col>
        <Form.Group>
          <Form.Label>CNPJ</Form.Label>
          <Form.Control
            value={document}
            required={paymentMethod == 2}
            disabled
          />
        </Form.Group>
      </Col>
    </Row>
  )

  const billetRender = () => ( // dados boleto
    <Row>
      <Col xs={6}>
        <Form.Group>
          <Form.Label>Data de Vencimento do Boleto</Form.Label>
          <Form.Control 
            value={dueDate ? parseDateBR(formatDate(dueDate)) : ""}
            disabled
          />
          {/* <DatePicker          
            className="form-control"
            dateFormat="dd/MM/yyyy"
            locale="pt_BR"
            selected={billetDueDate}
            onChange={(date) => setBilletDueDate(date)}
            minDate={new Date(new Date().setDate(new Date().getDate() + 10))}
          /> */}
        </Form.Group>
      </Col>
    </Row>
  )
  
  const getStatus = (statusParam) =>
  statusParam === 8 ? (
    <Badge variant="success" className="pt-2 pb-2 pr-2 pl-2">
      {t('statuses:approved_nf')}
    </Badge>
  ) : statusParam === 6 ? (
    <Badge variant="warning" className="pt-2 pb-2 pr-2 pl-2">
      {t('statuses:on_approval_nf')}
    </Badge>
  ) : statusParam === 7 ? (
    <Badge variant="danger" className="pt-2 pb-2 pr-2 pl-2">
      {t('statuses:disapproved_nf')}
    </Badge>
  ) : (
          <Badge variant="light" className="pt-2 pb-2 pr-2 pl-2">
            --
          </Badge>
        );

  const getDescription = (lista,status) => {
    let texto = '';
    if(lista && status===7){
      lista.filter(a=>a.status_id===7).forEach(i=>{
        texto += `Reprovado pelo ${i.profile.name}.</br>
        <p>Motivo: ${i.description}</p>`;
      });
    } else if(status===8){
      if(lista && lista.length===0){
        texto += 'NF Aprovada'
      }else if(lista){
        lista.filter(a=>a.status_id===8).forEach(i=>{
          texto += `NF Aprovada`;
        });
      }
    } else{
      texto += 'Aguardando Aprovação';
    }
    
    return texto;
  };

  return (
    <>
      <Modal size="lg" show={showModal} onHide={handleHideModal}>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:service provider')}</Form.Label>
                <Form.Control
                  value={serviceProvider}
                  onChange={(e) => setServiceProvider(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:registered number')}</Form.Label>
                <Input.CNPJ
                  value={document}
                  onChange={(e) => setDocument(e.target.value)}
                  required
                />
                {/* <Form.Control
                  value={document}
                  onChange={(e) => setDocument(e.target.value)}
                /> */}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:select item')}</Form.Label>
                <Form.Control
                  as="select"
                  value={item}
                  onChange={(e) => setItem(e.target.value)}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  {expectedItems.map((item, k) => (
                    <option key={k} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:invoice number')}</Form.Label>
                <Form.Control
                  value={invoiceNumber}
                  onChange={(e) => setInvoiceNumber(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Vai gerar pagamento ?</Form.Label>
                <Form.Control
                  as="select"
                  value={generatePayment ? 1 : 0}
                  onChange={(e) => {
                    setGeneratePayment(e.target.value == 1 ? true : false)
                    if (e.target.value == 0){
                      setPaymentMethod('');
                      setBankCode('');
                      setBankName('');
                      setAgency('');
                      setAccount('');
                      setBilletDueDate('');
                    }
                    setDueDate('');
                  }}
                >
                  <option value={1}>Sim</option>
                  <option value={0}>Não</option>
                </Form.Control>
              </Form.Group>
            </Col>
            
            <Col>
              <Form.Group>
                <Form.Label>
                  {t('label:expiry')}               
                </Form.Label>
                <DatePicker
                  className="form-control"
                  locale="pt-BR"
                  dateFormat="dd/MM/yyyy"
                  selected={dueDate}
                  onChange={(date) => setDueDate(date)}
                  minDate={paymentMethod == 1 ? dueDateMin : ""}
                  disabled={!generatePayment}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:issuance_date')}</Form.Label>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale="pt_BR"
                  selected={issuanceDate}
                  onChange={(date) => {setIssuanceDate(date);}}
                  required
                />
              </Form.Group>
            </Col>
            {paymentMethod == 1 && showAlert ? (
              <>
                <Col xs={12}>
                  <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                    <InfoRounded />{' '}
                    A data de vencimento para BOLETO deve ser de no mínimo 10 dias. Por favor altere a data de vencimento.
                  </Alert>
                </Col>
              </>
            ) : (
              null
            )}
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Form.Group>
                <Form.Label>{t('label:brief description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <FileUploadMultiple
                files={files}
                setFiles={(files) => setFiles(files)}
                filesComments={filesComments}
                setFilesComments={(filesComments) =>
                  setFilesComments(filesComments)
                }
                existingFiles={[]}
              />
            </Col>
          </Row>
          {generatePayment ? (<>
            <Row className="mt-2 mb-1">
              <Col><h5>Pagamento</h5></Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Forma de Pagamento</Form.Label>
                  <Form.Control
                    as="select"
                    value={paymentMethod}
                    onChange={(e) => {
                      setPaymentMethod(e.target.value)
                      if (e.target.value == 1 && dueDate != "") {
                        if (dueDateMin > dueDate) {
                          setDueDate("");
                          setShowAlert(true);
                        }                     
                      }
                    }}
                  >
                    <option value="" selected disabled>Selecione uma forma de Pagamento</option>
                    <option value={1}>Boleto</option>
                    <option value={2}>Transferência Bancária</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                {paymentMethod == 1 
                  ? billetRender() 
                  : paymentMethod == 2 
                    ? bankAccountRender()
                    : null 
                }
              </Col>
            </Row></>) 
          : null}
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project')}</Form.Label>
                <Form.Control
                  value={project}
                  onChange={(e) => setProject(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project action')}</Form.Label>
                <Form.Control
                  value={projectAction}
                  onChange={(e) => setProjectAction(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Reembolsável</Form.Label>
                <Currency
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Não Reembolsável</Form.Label>
                <Currency
                  value={valueNonRefundable}
                  onChange={(e) => setValueNonRefundable(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleHideModal}>
            {t('label:cancel')}
          </Button>
          {isLoad ? (
            <Row className="float-right text-right">
              <Spinner animation="border" style={{ color: '#e05c17' }} />
              <h6 className="m-2">Salvando...</h6>
            </Row>
          ) : (
            <Button size="sm" className="login-btn mr-1" variant="primary-login" onClick={handleSave}>
              {t('label:save')}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Row>
        <Col>
          <h4>{t('title:description amount company')}</h4>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Button size="sm" className="login-btn mr-1" variant="primary-login" onClick={() => setShowModal(true)}>
            <i className="fas fa-plus"></i> {t('label:add new')}
          </Button>
        </Col>
      </Row>
      {expenseDescriptions.map((description, k) => (
        <Row key={k}>
          <Col
            className={`${style.expenseDescription} ${
              description.hidden ? style.hidden : null
            }`}
          >
            <Card className="mt-4" body>
              <Row className="justify-content-between">
                <Col xs="auto">
                  <ReactTooltip />
                  <h5 className="" data-html={true} 
                  data-tip={getDescription(description.approval_history,description.status_id)}
                  >{getStatus(description.status_id)}</h5>
                </Col>
                <Col>
                  {description.hidden ? (
                      <i
                        className="expenseDescriptionIcon fas fa-plus"
                        onClick={() => setHidden(false, k)}
                      />
                  ) : (
                      <i
                        className="expenseDescriptionIcon fas fa-minus"
                        onClick={() => setHidden(true, k)}
                      />
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:service provider')}</Form.Label>
                    <Form.Control
                      value={description.service_provider}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:item')}</Form.Label>
                    <Form.Control
                      value={description.event_item_id}
                      as="select"
                      disabled
                    >
                      <option disabled value="">
                        {t('label:select')}
                      </option>
                      {expectedItems.map((item, k) => (
                        <option key={k} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:invoice number')}</Form.Label>
                    <Form.Control value={description.invoice_number} disabled />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:expiry')}</Form.Label>
                    <DatePicker
                      className="form-control"
                      locale="pt-BR"
                      dateFormat="dd/MM/yyyy"
                      selected={description.due_date}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:issuance_date')}</Form.Label>
                    <DatePicker
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      locale="pt_BR"
                      selected={description.issuance_date?description.issuance_date:''}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:value')}</Form.Label>
                    <Currency value={description.value} disabled />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12}>
                  <Form.Group>
                    <Form.Label>{t('label:brief description')}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows="4"
                      value={description.description}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  {description.files.map((file, k) => (
                    <File
                    // key={k}
                    extension={file.extension}
                    comment={file.comment}
                    uri={file.uri}
                    />
                  ))}
                </Col>
              </Row>
              {description.generate_payment ? (<>
                <Row>
                  <Col>
                    <h5>Informações de Pagamento</h5>
                  </Col>
                </Row>
                <Row>
                  {description.payment_method_id == 1 
                  ? (
                      <>
                        <Col>
                          <Form.Group>
                            <Form.Label>Tipo</Form.Label>
                            <Form.Control
                              value={'Boleto'}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label>{t('label:expiry')}</Form.Label>
                            <DatePicker
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              locale="pt_BR"
                              selected={new Date(description.billet_due_date)}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )
                  : (
                    <>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label>Tipo</Form.Label>
                          <Form.Control
                            value={'Transferência Bancária'}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label>Banco</Form.Label>
                          <Form.Control
                            value={getBankName(description.bank_code)}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={4}>
                        <Form.Group>
                          <Form.Label>Agência</Form.Label>
                          <Form.Control
                            value={description.agency}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={4}>
                        <Form.Group>
                          <Form.Label>Conta</Form.Label>
                          <Form.Control
                            value={description.account}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={4}>
                        <Form.Group>
                          <Form.Label>CNPJ</Form.Label>
                          <Form.Control
                            value={description.document}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}                  
                </Row>
              </>) : null}
              <Row className="mt-2">
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:nature')}</Form.Label>
                    <Form.Control value={description.nature} disabled />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:cost center')}</Form.Label>
                    <Form.Control value={description.cost_center} disabled />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:project')}</Form.Label>
                    <Form.Control value={description.project} disabled />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:project action')}</Form.Label>
                    <Form.Control value={description.project_action} disabled />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button size="sm" 
                  onClick={() => handleEdit(k)}
                  disabled={description.status_id!=7}>
                    {t('label:edit')}
                  </Button>
                  <Button
                  disabled={description.status_id!=7}
                    size="sm"
                    variant="danger"
                    className="ml-1"
                    onClick={() => handleDelete(description.id)}
                  >
                    <i className="fas fa-times" />
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      ))}
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  loading: (payload) => dispatch({ type: LOADING, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsFormExpenseDescriptions);
